<template>
  <v-container fluid class="pt-0">
    <v-layout row wrap class="hide-on-print">
      <v-flex xs12>
        <v-card>
          <v-tabs
              fixed-tabs
              background-color="primary"
              dark
              height="40"
              v-model="tab">
            <v-tab href="#detail">
              <v-icon class="mr-2" size="15">mdi-account-card-details</v-icon>
              SCP Detail
            </v-tab>
            <v-tab href="#history">
              <v-icon class="mr-2" size="15">mdi-history</v-icon>
              SCP History
            </v-tab>

            <v-tabs-items v-model="tab">
              <v-tab-item value="detail">
                <v-card flat class="pb-0" :loading="checkPaymentLoading">

                  <v-toolbar class="elevation-0" color="none">
                    <v-toolbar-title>
                      <b class="text-primary">
                        Special case payment Detail
                        <span
                            style="color: #212020;font-size: 15px;"></span>
                        <v-chip class="text-white ml-2" :color="scpDetail.status === 67?'success':'primary'">
                          &nbsp; ({{ latest_status }})
                        </v-chip>
                      </b>
                    </v-toolbar-title>
                    <v-spacer/>
                  </v-toolbar>

                  <v-card-text class="pt-0 " v-if="scpDetail && scpDetail.extra">
                    <v-layout class="pb-2" row style="background: #ffffff" wrap>

                      <v-layout row wrap class="pl-6">
                        <confirmation-header-text icon="mdi-card-bulleted" text="Voucher Detail" class="ml-0"/>

                        <v-flex sm3 xs12>
                          <list-item-detail :sub_title="scpDetail.extra.submission_no"
                                            title="Submission Id"/>
                        </v-flex>
                        <v-flex sm3 xs12>
                          <list-item-detail :sub_title="scpDetail.cost"
                                            title="Amount(USD)"/>
                        </v-flex>
                        <v-flex sm3 xs12>
                          <list-item-detail :sub_title="scpDetail.extra.revenueType"
                                            title="Revenue Type"/>
                        </v-flex>
                        <v-flex sm3 xs12 v-if="scpDetail.extra.voucher_number">
                          <list-item-detail :sub_title="scpDetail.extra.voucher_number"
                                            title="Voucher Number"/>
                        </v-flex>
                        <v-flex sm3 xs12>
                          <list-item-detail :sub_title="scpDetail.extra.title"
                                            title="Title" :show-tooltip="true"/>
                        </v-flex>
                        <v-flex sm3 xs12>
                          <list-item-detail :sub_title="scpDetail.extra.description"
                                            title="Description" :show-tooltip="true"/>
                        </v-flex>


                      </v-layout>


                      <v-flex xs12>
                        <v-divider class="mb-2"/>
                      </v-flex>

                      <v-layout class="pl-6" row wrap>
                        <confirmation-header-text class="ml-2" icon="mdi-file-document" text="Documents"/>
                        <v-flex sm3>
                          <list-item-detail
                              :sub_title=" scpDetail.type"
                              title="Document Type"
                          />
                        </v-flex>

                        <v-flex sm3>
                          <list-item-detail
                              :sub_title="scpDetail.document_number"
                              title="Document Number"
                          />
                        </v-flex>

                        <v-flex sm3>
                          <list-item-detail
                              :sub_title="scpDetail.validity"
                              title="Expiry Date"
                          />
                        </v-flex>

                        <v-flex sm2>
                          <file-list-item-detail :src="scpDetail.document_file"
                                                 sub_title="Attachment"></file-list-item-detail>
                        </v-flex>

                      </v-layout>

                      <v-flex xs12>
                        <v-divider class="mb-2"/>
                      </v-flex>


                      <v-layout row wrap pl-6>

                        <v-flex class="pb-1 d-flex justify-space-between " xs12>
                          <confirmation-header-text class="ml-2"
                                                    icon="mdi-account-box"
                                                    text="Personal Details"/>
                          <v-btn
                              @click="viewHistory(scpDetail.traveller)"
                              color="primary"
                              dark
                              dense
                              small
                              text
                              v-if="scpDetail.traveller">
                            View Details
                          </v-btn>
                        </v-flex>
                        <v-flex sm3 xs12 class="pl-3">
                          <list-item-detail :sub_title="scpDetail.full_name"
                                            title="Name"/>
                        </v-flex>
                        <v-flex md3 xs12>
                          <list-item-detail :sub_title="scpDetail.country_name"
                                            title="Country"/>
                        </v-flex>

                        <v-flex md3 xs12>
                          <list-item-detail :sub_title="scpDetail.dob"
                                            title="Date of Birth"/>
                        </v-flex>

                        <v-flex sm3 xs12>
                          <file-list-item-detail :avatar="true"
                                                 :src="scpDetail.user_image"
                                                 sub_title="User Image">
                          </file-list-item-detail>
                        </v-flex>


                        <v-flex sm3 xs12 pl-3>
                          <list-item-detail :sub_title="scpDetail.gender"
                                            title="Gender">
                          </list-item-detail>
                        </v-flex>

                        <v-flex sm3 xs12>
                          <list-item-detail
                              :sub_title="scpDetail && scpDetail.occupation ? scpDetail.occupation.name:  scpDetail.occupation"
                              title="Occupation">
                          </list-item-detail>
                        </v-flex>

                        <v-flex sm3 xs12>
                          <list-item-detail :sub_title="scpDetail.full_address" :show-tooltip="true"
                                            :title="'Address  of ' +(scpDetail.country_name)">
                          </list-item-detail>
                        </v-flex>
                        <v-flex sm3 xs12>
                          <list-item-detail :sub_title="scpDetail.email"
                                            title="Email Address">
                          </list-item-detail>
                        </v-flex>

                        <v-flex sm3 xs12 class="pl-3">
                          <list-item-detail :sub_title="scpDetail.contact_number_in_nepal"
                                            title="Contact Number">
                          </list-item-detail>
                        </v-flex>

                      </v-layout>

                      <v-flex xs12>
                        <v-divider class="mb-2"/>
                      </v-flex>

                      <v-flex xs12 v-if="scpDetail.extra.paid">
                        <confirmation-header-text class="ml-2" icon="mdi-alpha-p-box"
                                                  text="Payment Details"/>

                        <span>

            <v-layout class="pl-6" row v-if="scpDetail.extra.payment_detail && scpDetail.extra.payment_detail.ebp_no"
                      wrap>
                    <v-flex sm3 xs12>
                        <list-item-detail sub_title="Malenika" title="Payment method"/>
                    </v-flex>
                    <v-flex sm3 xs12>
                        <list-item-detail :sub_title="scpDetail.extra.payment_detail.voucher_number"
                                          title="Voucher Number"/>
                    </v-flex>
                    <v-flex sm3 xs12>
                        <list-item-detail :sub_title="scpDetail.extra.payment_detail.bank_name"
                                          title="Bank name"/>
                    </v-flex>
                    <v-flex sm3 xs12>
                        <list-item-detail :sub_title="scpDetail.extra.payment_detail.ebp_no"
                                          title="EBP No"/>
                    </v-flex>

                    <v-flex sm3 xs12>
                        <list-item-detail :sub_title="scpDetail.extra.payment_detail.revenue_head"
                                          title="Revenue head"/>
                    </v-flex>
                    <v-flex sm3 xs12>
                        <list-item-detail :sub_title="scpDetail.extra.payment_detail.total_amount"
                                          title="Total amount(NPR)"/>
                    </v-flex>
                    <v-flex sm12 xs12>
                        <list-item-detail :sub_title="scpDetail.extra.payment_detail.payment_description"
                                          title="Payment description"/>
                    </v-flex>
            </v-layout>
            <v-layout class="px-6" row v-else wrap>
                <v-flex sm3 xs12><list-item-detail sub_title="Manual" title="Payment method"/></v-flex>
                <v-flex sm3 xs12>
                    <list-item-detail :sub_title="scpDetail.extra.amount_usd" title="Total amount (USD)"/>
                </v-flex>

                <v-flex sm3 xs12>
                    <list-item-detail :sub_title="scpDetail.extra.amount_npr" title="Total amount (NPR)"/>
                </v-flex>


                <v-flex sm3 xs12>
                    <list-item-detail :sub_title="scpDetail.extra.bank" title="Bank/Office name"/>
                </v-flex>
                <v-flex sm3 xs12>
                    <list-item-detail :sub_title="scpDetail.extra.invoice_number" title="Invoice number"/>
                </v-flex>
            </v-layout>
        </span>
                      </v-flex>


                      <manual-payment-dialog :url="'special-case-payment/pay-manually/'+scpDetail.extra.submission_no"
                                             @paid="loadData" v-model="manualPaymentDialog"/>


                    </v-layout>
                    <v-footer class="sticky" color="primary lighten-2" fixed height="auto"
                              v-if="scpDetail.can_process && showBtn">
                      <v-layout row wrap>
                        <v-spacer/>


                        <v-btn @click="print('voucher')" class="text-white ml-2" color="blue"

                        >
                          Print Voucher
                        </v-btn>
                        <v-btn :loading="checkPaymentLoading" @click="payManually" class="text-white ml-2" color="blue">
                          Pay Manually
                        </v-btn>
                        <v-btn :loading="checkPaymentLoading" @click="checkPayment" class="text-white ml-2" color="blue"
                               v-if="scpDetail.extra.voucher_number">
                          Check Payment
                        </v-btn>
                        <v-btn @click="deleteSCPDetail" class="text-white ml-2" color="red">
                          Delete
                        </v-btn>
                        <!--          <v-btn-->
                        <!--              @click="attachDocument"-->
                        <!--              class="white&#45;&#45;text"-->
                        <!--              color="primary ml-2"-->
                        <!--              v-if="showAttachDocuments"-->
                        <!--          >-->
                        <!--            Attach Document(s)-->
                        <!--          </v-btn>-->


                      </v-layout>
                    </v-footer>
                  </v-card-text>


                </v-card>
              </v-tab-item>

              <v-tab-item value="history">
                <v-card flat :loading="checkPaymentLoading">
                  <visa-history :history="scpDetail.history"
                                :show_load_more="false" :editable="false"/>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
        </v-card>
      </v-flex>
    </v-layout>

    <s-c-p-voucher-print-content v-if="printVoucherDialog" style="display: none"/>
  </v-container>
</template>
<style>
.hide {
  display: none;
}
</style>
<script>
import {
  SET_GENERATED_TIPPANI,
  SET_PRINT_CONTENT,
  SET_PRINT_CONTENT_ONLY,
  SET_SELECTED_TIPPANI
} from "../../store/mutation-type";

import {VERSIONED_API_URL} from "../../config/config";
import Http from 'axios';

import {validationMixin} from "../../mixins/validationMixin";
import ManualPaymentDialog from "../../components/dialogs/ManualPaymentDialog"

import ListItemDetail from "../../components/ListItemDetail";
import FileListItemDetail from "../../components/FileListItemDetail";
import AttachedDocument from "../../components/AttachedDocument";

import ConfirmationHeaderText from "../../components/ConfirmationHeaderText";
import AvatarImageModal from "../../components/AvatarImageModal";
import FileDisplay from "../../components/FileDisplay";
import DialogFile from "../../components/FileDisplay";

import {mapActions, mapGetters} from 'vuex';

import AttachFileDialog from "../../components/dialogs/AttachFileDialog";
import SCPVoucherPrintContent from "../../components/dialogs/SCPVoucherPrintContent";
import VisaHistory from "../visa/visa-request/VisaHistory";


export default {
  name: "SCPDetail",

  mixins: [validationMixin],
  data() {
    return {
      manualPaymentDialog: false,
      // attachFileDialog: false,
      printVoucherDialog: false,
      tab: null,

    }
  },
  components: {
    VisaHistory,
    AttachFileDialog,
    ConfirmationHeaderText,
    ListItemDetail,
    FileDisplay,
    AvatarImageModal,
    DialogFile,
    FileListItemDetail,
    AttachedDocument,
    ManualPaymentDialog,
    SCPVoucherPrintContent

  },
  computed: {
    ...mapGetters({
      scpDetail: "TravellerSingle/special_case_payment_detail",
      checkPaymentLoading: "TravellerSingle/loading"
    }),

    latest_status() {
      const latest_status = this.scpDetail && this.scpDetail.history ? this.scpDetail.history[0] : null;
      return latest_status.status;
    },

    // fileAlreadyAttached() {
    //   const {file_attached} = this.visa_request;
    //   return file_attached;
    // },

    showBtn() {
      return !this.scpDetail.extra.paid && this.scpDetail.status === 66;
    }

    // showAttachDocuments() {
    //   const {approve_rejected, paid, can_attach_file, payment_detail} = this.visa_request;
    //
    //   // if (parseInt(payment_detail.amount) === 0) {
    //   //   return !approve_rejected && can_attach_file;
    //   // }
    //   // return !approve_rejected && can_attach_file;
    //   return can_attach_file;
    //
    // },


  },
  methods: {
    ...mapActions({
      getSCPDetail: 'TravellerSingle/getSpecialCasePaymentDetail',
    }),

    // attachDocument() {
    //   this.attachFileDialog = true;
    // },
    async deleteSCPDetail() {
      await this.$dialog.confirm({
        text: "Are you sure want to delete this record ?",
        actions: {
          false: "No",
          true: {
            text: "Yes",
            handle: async () => {
              await this.deleteThis();
            }
          }
        }
      });
    },

    payManually() {
      this.manualPaymentDialog = true;
    },

    viewHistory(item) {
      window.open('/admin/system/travellers-history/view/' + item, '_blank');
    },


    async checkPayment() {
      try {
        let response = await Http.put(`${VERSIONED_API_URL}/special-case-payment/check-payment-status/${this.scpDetail.extra.submission_no}`);
        this.$store.commit('Notification/showSuccess', 'Amount has been paid')
      } catch (e) {
        this.$store.commit('Notification/showError', e.response.data.message)
      }
    },

    async deleteThis() {
      try {
        let response = await Http.delete(`${VERSIONED_API_URL}/special-case-payment/delete/${this.scpDetail.extra.submission_no}`);
        this.$store.commit('Notification/showSuccess', 'Record has been paid');
        this.$router.push({
          name: "SCPList"
        });
      } catch (e) {
        this.$store.commit('Notification/showError', e.response.data.message)
      }
    },
    print() {
      const content = document.getElementById('scp_voucher_print_content').innerHTML;
      this.$store.commit(SET_PRINT_CONTENT, content);
    },
    loadData() {
      this.getSCPDetail(this.$route.params.id)
          .then(() => this.printVoucherDialog = true)
          .catch((err) => {
            this.$store.commit("Notification/showError", err.response.data.message);
          });
    }
  },
  mounted() {
    this.loadData();
  }
}
</script>
